var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.889,
    height: 16.19,
    viewBox: "0 0 18.889 16.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "suitcase",
    d: "M6.746,2.7h5.4V1.349h-5.4V2.7Zm-3.71,0V16.19H2.361a2.272,2.272,0,0,1-1.665-.7A2.272,2.272,0,0,1,0,13.829V5.06A2.272,2.272,0,0,1,.7,3.394a2.272,2.272,0,0,1,1.665-.7h.675Zm11.805,0V16.19H4.047V2.7H5.4V1.012A.975.975,0,0,1,5.692.3.979.979,0,0,1,6.409,0H12.48A.975.975,0,0,1,13.2.3a.979.979,0,0,1,.3.717V2.7h1.349ZM18.889,5.06v8.77a2.376,2.376,0,0,1-2.361,2.361h-.675V2.7h.675a2.272,2.272,0,0,1,1.665.7A2.272,2.272,0,0,1,18.889,5.06Z",
    fill: "#888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.2ce81d27a192feee7c96e2741b1e15c8.svg";
export { ForwardRef as ReactComponent };